import React, { Component } from 'react'
import {connect} from 'react-redux'
import ListLoyalty from './ListLoyalty'
import ListNonLoyalty from './ListNonLoyalty'
import ToggleDisplay from 'react-toggle-display'
import RedeemHistory from './RedeemHistory'
import PurchaseHistory from './PurchaseHistory'
import PointActivity from './PointActivity'
import {customerRedemptionHistoriesRequest, customerPointActivitiesRequest, pageRequest} from 'actions/customers/list'

class CustomerList extends Component {

  constructor (props) {
    super(props)

    let views = ['loyalty', 'non-loyalty', 'redeemHistory', 'purchaseHistory', 'pointActivity']
    let currentView = ''

    if (this.props.hasLoyalty) {
      currentView = views[0]
    } else if (this.props.hasLoyalty === false) {
      currentView = views[1]
    }

    this.state = ({ views, currentView })
  }

  componentWillMount () {
    this.props.pageRequest()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.hasLoyalty !== nextProps.hasLoyalty) {
      if (nextProps.hasLoyalty) {
        this.setState({currentView: this.state.views[0]})
      } else {
        this.setState({currentView: this.state.views[1]})
      }
    }
  }

  render () {
    const { views, currentView } = this.state
    return (
      <div style={{height: '100%'}}>
        <ToggleDisplay show={currentView === views[0] || currentView === views[1]}>
          {this.props.hasLoyalty &&
            <ListLoyalty
              showRedeemHistory={this._showRedeemHistory}
              showPurchaseHistory={this._showPurchaseHistory}
              showPointActivity={this._showPointActivity}
             />
          }
          {!this.props.hasLoyalty && <ListNonLoyalty />}
        </ToggleDisplay>
        {views[2] === currentView && <RedeemHistory backToCustomerList={this._showListLoyalty} />}
        {views[3] === currentView && <PurchaseHistory backToCustomerList={this._showListLoyalty} />}
        {views[4] === currentView && <PointActivity backToCustomerList={this._showListLoyalty} />}
      </div>
    )
  }

  _showPointActivity = (customerId) => {
    this.props.customerPointActivitiesRequest({customerId, page: 1, size: 12, sort: 'createdAt,desc'})
    this.setState({ currentView: this.state.views[4] })
  }

  _showRedeemHistory = (customerId) => {
    this.props.customerRedemptionHistoriesRequest({customerId, page: 1, size: 12, sort: 'createdAt,desc'})
    this.setState({ currentView: this.state.views[2] })
  }

  _showListLoyalty = () => {
    this.setState({ currentView: this.state.views[0] })
  }

  // the behaviour of purchase history is different because there is not server side pagination provided
  _showPurchaseHistory = () => {
    this.setState({ currentView: this.state.views[3] })
  }

}

CustomerList.propTypes = {
  hasLoyalty: React.PropTypes.object
}

function mapStateToProps ({customers: {list: {hasLoyalty}}}) {
  return { hasLoyalty }
}

export default connect(mapStateToProps, {
  customerRedemptionHistoriesRequest,
  customerPointActivitiesRequest,
  pageRequest
})(CustomerList)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/CustomerList.js